/**
 * getDayOfWeek - get the date (ex. monday/tuesday) for loading in audio
 */
export const getDayOfWeek = () => {
  const date = new Date();
  const day = date.getDay();

  return day;
};
